/**
 * Portado do `enamed-feedback-lp`, com os mesmos testes.
 *
 * O bucket do Firebase Storage **da Aristo**, de onde vêm as imagens das
 * questões. É outro projeto do Firebase, e não o `primum-core` deste app — por
 * isso não passa pelo SDK: a URL pública de download basta, e o SDK de Storage
 * seria uma dependência a mais só para montar uma string.
 */
const BUCKET = (import.meta.env.VITE_ARISTO_STORAGE_BUCKET ?? '').trim();

/**
 * O caminho que a Aristo grava no enunciado, virado em URL que o navegador abre.
 *
 * - **Caminho relativo** (`images/questions/x_body.png`) é relativo ao bucket, e
 *   vira `…/o/<caminho codificado>?alt=media`. As barras **precisam** ir
 *   codificadas (`%2F`): a API de download trata o caminho como o nome de um
 *   objeto só, e com barras cruas ela responde `404`.
 * - **URL `https` absoluta** passa como veio.
 * - **Qualquer outra coisa é recusada** — `javascript:`, `data:`, `http:` sem
 *   TLS e caminho que sobe diretório. O texto vem de um banco que não é nosso,
 *   e o que sai daqui vira `src` e `href` na página.
 * - **Sem bucket configurado, caminho relativo é recusado**, e a tela avisa que
 *   a imagem não carregou em vez de montar uma URL quebrada.
 */
export function resolveAristoImageUrl(
  path: string,
  bucket: string = BUCKET,
): string | null {
  const trimmed = path.trim();
  if (!trimmed) return null;

  if (/^[a-z][a-z0-9+.-]*:/i.test(trimmed)) {
    return /^https:\/\//i.test(trimmed) ? trimmed : null;
  }

  if (trimmed.startsWith('//') || trimmed.split('/').includes('..')) {
    return null;
  }
  if (!bucket) return null;

  const objectName = encodeURIComponent(trimmed.replace(/^\/+/, ''));
  return `https://firebasestorage.googleapis.com/v0/b/${encodeURIComponent(bucket)}/o/${objectName}?alt=media`;
}
